import { gql } from '@apollo/client'

export const completeDailyAction = gql`
  mutation CompleteDailyAction($action: String!) {
    completeDailyAction(action: $action)
  }
`
